import React from 'react';
import PropTypes from 'prop-types';

const MenuPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M4 22.999A1 1 0 0 1 5.001 22h21.998a.997.997 0 0 1 1.001.999v1.002a1 1 0 0 1-1.001.999H5.001A.997.997 0 0 1 4 24.001v-1.002zm0-8A1 1 0 0 1 5.001 14h21.998a.997.997 0 0 1 1.001.999v1.002a1 1 0 0 1-1.001.999H5.001A.997.997 0 0 1 4 16.001v-1.002zm0-8A1 1 0 0 1 5.001 6h21.998A.997.997 0 0 1 28 6.999v1.002A1 1 0 0 1 26.999 9H5.001A.997.997 0 0 1 4 8.001V6.999z"
    />
  );
};

MenuPath.propTypes = {
  fill: PropTypes.string,
};

export default MenuPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/menu.jsx